var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportList"},[_c('transition',{attrs:{"enter-active-class":"animated slideInDown","leave-active-class":"animated slideOutUp"}},[(_vm.hasCurrentReport)?_c('div',{staticClass:"currentReport"},[_c('nuxt-link',{attrs:{"to":_vm.moveTo}},[_vm._v(_vm._s(_vm.getMessage(_vm.current)))])],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }